import { render, staticRenderFns } from "./ProgressStatus.vue?vue&type=template&id=2db4a592&scoped=true"
import script from "./ProgressStatus.vue?vue&type=script&lang=js"
export * from "./ProgressStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4a592",
  null
  
)

export default component.exports